import { LitElement, html, css } from 'lit'
import '../../../bui/presenters/tabs'
import '../../../bui/presenters/tabs/tab-bar/pill-bar'
import '../../../bui/elements/details'
import '../../../bui/elements/btn'
import '../../../bui/elements/animated-bgd'
import BaseTabBar from '../../../bui/presenters/tabs/tab-bar/_base'

customElements.define('k-trips-tab-bar', class extends BaseTabBar{

    static styles = css`
        :host {
            display: flex;
            border-bottom: none !important;
            margin-bottom: 1em;
            overflow: visible !important;
        }

        b-animated-bgd {
            display: flex;
            gap: 2em;
            justify-content: flex-start;
            flex-grow: 1;
        }

        b-animated-bgd::part(bgd) {
            
            z-index: -1;
            height: 4px;
        }

        b-text {
            padding: 0;
            font-family: var(--font-btn);
            transition-duration: var(--animated-bgd-duration);
            transition-property: color;
            transition-timing-function: var(--animated-bgd-timing);
            padding: .5em;
            margin: -.5em;
            cursor: default;
            font-weight: bold;
            text-transform: uppercase;
        }

        b-text:hover {
            color: var(--green);
        }

        b-text[active] {
            color: var(--blue);
            /*color: var(--animated-bgd-text-color);*/
        }

        .active {
            width: 100%;
            height: 1.6em;
            position: absolute;
            bottom: -.25em;
            text-align: center;
        }

        .active svg {
            height: 1.6em;
        }

        .active {
            background-color: var(--orange);
            height: .25em;
            clip-path: polygon(.1em 0, 100% 0, 99% 100%, 0 100%);
            transform: translateY(1.8em);
        }

    `
    renderLoop(){ return html`
        <b-animated-bgd _color="orange">
            <div class="active" slot="bgd"></div>
            ${super.renderLoop()}
        </b-animated-bgd>
    `}

    renderBtn(view){ return html`
        <b-text icon="${view.icon}" ?active=${view.active} .tabView=${view} @click=${this.onMenuClick}>
            ${view.title}
        </b-text>
    `}

})

export default customElements.get('k-trips-tab-bar')

